export default class Commercial {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        commercialRetrieve(id: ${id}) {
          id
          url
          company {
            id
            name
            description
            openTime
            closeTime
            phoneNumber
          }
          image {
            id
            url
          }
          clicks
          displayed
          coupons {
            id
            title
            subTitle
            categories {
              id
              name
            }
            images {
              id
              url
            }
            initialDate
            expirationDate
            description
            discount
            distinguished
            hot
            new
            price
            saveValue
            value
          }
          name
          description
          active
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.commercialRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        commercialList {
          results {
            id
            url
            company {
              id
              name
              description
              openTime
              closeTime
              phoneNumber
            }
            image {
              id
              url
            }
            clicks
            displayed
            coupons {
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value
            }
            name
            description
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.commercialList.results.reverse();
  }

  static async allOfCompany(axios, company) {
    const response = await axios.post(
      '/graphql/',
      `query {
        commercialList(company: ${company}) {
          results {
            id
            url
            company {
              id
              name
              description
              openTime
              closeTime
              phoneNumber
            }
            image {
              id
              url
            }
            clicks
            displayed
            coupons {
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value
            }
            name
            description
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.commercialList.results.reverse();
  }

  static async filter(axios, active) {
    const response = await axios.post(
      '/graphql/',
      `query{
        commercialList (active: ${active}){
          results {
            id
            url
            company {
              id
              name
              description
              openTime
              closeTime
              phoneNumber
            }
            image {
              id
              url
            }
            clicks
            displayed
            coupons {
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value
            }
            name
            description
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.commercialList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteCommercial ($id: ID!){
          deleteCommercial(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteCommercial.ok;
  }

  static async create(axios, name, description, url, image, company, coupons, active) {
    const couponsField = (coupons > 0) ? `coupons: ${coupons},` : ``;
    const companyField = (company > 0) ? `company: ${company},` : ``;
    const imageField = (image > 0) ? `image: ${image},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation {
        createCommercial(newCommercial:{
          ${couponsField}
          ${companyField}
          ${imageField}
          name: "${name}",
          description: "${description}",
          url: "${url}",
          active: ${active},
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCommercial.ok;
  }

  static async edit(axios, id, name, description, url, image, company, coupons, active) {
    const couponsField = (coupons > 0) ? `coupons: ${coupons},` : ``;
    const companyField = (company > 0) ? `company: ${company},` : ``;
    const imageField = (image > 0) ? `image: ${image},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCommercial(newCommercial:{
          ${couponsField}
          ${companyField}
          ${imageField}
          id: "${id}",
          name: "${name}",
          description: "${description}",
          url: "${url}",
          active: ${active},
        }){
          ok
          errors {
            messages
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCommercial.ok;
  }


}